
import { Component } from 'vue-property-decorator';
import RemoteDataTable, {
  RemoteDataField
} from '@/components/RemoteDataTable.vue';
import ModifierItemAddEdit from './ModifierItemAddEdit.vue';
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

class ModifierItemItem {
  id: string = '';
  outletCode: string = '';
  modifierGroupCode: string = '';
  modifierItemCode: string = '';
  sequence: number = 0;
  isTaxable: boolean = false;
  isActive: boolean = false;
  isCD: boolean = false;
}

@Component({
  components: {
    editor: ModifierItemAddEdit
  }
})
export default class ModifierItemList extends RemoteDataTable<
  ModifierItemItem
  > {
  public pageTitle: string = 'Modifier Item List';

  public newButtonText: string = 'New ModifierItem';

  public fieldsSet: Array<RemoteDataField> = [
    new RemoteDataField({ key: 'index', label: '', sortable: false }),
    new RemoteDataField({ key: 'action', label: '', sortable: false }),
    new RemoteDataField({ key: 'outletCode', label: 'Outlet Code' }),
    new RemoteDataField({
      key: 'modifierGroupCode',
      label: 'Modifier Group Code'
    }),
    new RemoteDataField({
      key: 'modifierItemCode',
      label: 'Modifier Item Code'
    }),
    new RemoteDataField({ key: 'sequence', label: 'Sequence' }),
    new RemoteDataField({ key: 'isTaxable', label: 'Is Taxable' }),
    new RemoteDataField({ key: 'isActive', label: 'Is Active' }),
    new RemoteDataField({ key: 'isCD', label: 'Is CD' })
  ];

  // to get page data
  get items(): ModifierItemItem[] {
    return this.$store.getters.GetAllModifierItem;
  }

  get paging(): ModifierItemItem[] {
    return this.$store.getters.PagingModifierItem;
  }

  get sorting(): ModifierItemItem[] {
    return this.$store.getters.SortingModifierItem;
  }

  get filtering(): ModifierItemItem[] {
    return this.$store.getters.FilteringModifierItem;
  }

  resetSorting() {
    this.sortingChanged({ sortBy: '', sortDesc: '' });
  }

  resetFilter() {
    this.filterChanged(true);
  }

  sortingChanged(ctx) {
    this.$store.dispatch('UpdateSortingModifierItem', {
      byField: ctx.sortBy,
      isDesc: ctx.sortDesc
    });
  }

  filterChanged(isResetFilter) {
    this.$store.dispatch('UpdateFilteringModifierItem', {
      isResetFilter: isResetFilter
    });
  }

  reload(id = null) {
    if (id === 1) {
      this.$store.state.modifierItem.pagingModifierItem.page = 1;
    }
    this.$store.dispatch('GetAllModifierItem');
  }

  // delete item
  deleteItem(item) {
    this.$swal({
      title: constants.ARE_YOU_SURE,
      text: constants.CONFIRM_DELETE_ITEM,
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        this.$store
          .dispatch('DeleteModifierItem', item.id)
          .then(response => {
            getResponseToMTH(response, this.$swal, constants.RECORD_IS_DELETED);
          })
          .catch(error => {
            this.$swal(
              constants.SOMETHING_WROING,
              error.response.data.message,
              constants.STATUS_ERROR
            );
          });
      }
    });
  }

  setPerPage(page) {
    this.$store.state.modifierItem.pagingModifierItem.size = page;
    this.$store.dispatch('GetAllModifierItem');
  }
}
